export default "__VITE_ASSET__Cbro20x6__"